import { LeagueClassicPage } from './LeagueClassicPage.js';
import { LeagueMediaMini }   from './LeagueMediaMini.js';
/**
 * LeagueBrasileiroFem.js &#8212; auto-generated
 * Architecture mirrors LeagueWSL.js &#8212; responsive, CSS-injected.
 */
import { BRF_STANDINGS, BRF_SCORERS, BRF_FIXTURES, fetchLiveBRFData } from '../../data/brasileiroFemData.js';
import { injectCSS, gdHtml, formPills, fmtDate, BASE_CSS } from '../../leagueBase.js';

const STYLE_ID = 'leaguebrasileirofem-styles';
const ACCENT   = '#009C3B';

function inject() {
  injectCSS(STYLE_ID, BASE_CSS + `
    .leaguebrasileirofem-tab.active { border-bottom-color: ${ACCENT}; }
    .leaguebrasileirofem-badge { background: ${ACCENT}; color: #fff; }
    .leaguebrasileirofem-scorer-g { color: ${ACCENT}; }
    .leaguebrasileirofem-pts { color: ${ACCENT}; font-weight:700; }
    
  `);
}

// &#9472;&#9472; HTML helpers &#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;
function fixtureSidebar(fixtures = []) {
  const shown = [...(fixtures.filter(f=>f.status==='FT').slice(-3)),
                 ...(fixtures.filter(f=>f.status==='NS').slice(0,3))];
  return shown.map(f => `
    <div class="lg-fix">
      <div class="lg-fix-date">${fmtDate(f.date)}</div>
      <div class="lg-fix-teams">
        <div class="lg-fix-team"><div class="lg-dot" style="background:${f.homeColor||ACCENT}"></div><span class="lg-fix-name">${f.home}</span></div>
        <div class="lg-fix-team"><div class="lg-dot" style="background:${f.awayColor||'#999'}"></div><span class="lg-fix-name">${f.away}</span></div>
      </div>
      <div class="lg-fix-score ${f.status==='NS'?'upcoming':''}">${f.status==='NS'?'vs':`${f.homeGoals}&#8211;${f.awayGoals}`}</div>
    </div>`).join('');
}

function scorerSidebar(scorers = []) {
  return scorers.slice(0,6).map((s,i) => `
    <div class="lg-scorer">
      <div class="lg-scorer-rank">${i+1}</div>
      <div class="lg-av">${s.initials}</div>
      <div class="lg-scorer-info"><div class="lg-scorer-name">${s.name}</div><div class="lg-scorer-club">${s.club}</div></div>
      <div class="lg-scorer-g">${s.goals}</div>
    </div>`).join('');
}

function standingsRows(rows = []) {
  return rows.map(t => `
    <tr class="lg-zone-${t.zone||'n'}">
      <td>${t.pos}</td>
      <td class="l"><div class="lg-team-cell"><div class="lg-dot" style="background:${t.color}"></div><span class="lg-name">${t.name}</span></div></td>
      <td>${t.p}</td>
      <td class="lg-col-hide">${t.w}</td>
      <td class="lg-col-hide">${t.d}</td>
      <td class="lg-col-hide">${t.l}</td>
      <td class="lg-col-hide">${gdHtml(t.gd)}</td>
      <td class="lg-pts">${t.pts}</td>
      <td class="lg-col-hide"><div class="lg-form">${formPills(t.form||[])}</div></td>
    </tr>`).join('');
}

function tableHtml(rows) {
  return `<table class="lg-table">
    <thead><tr>
      <th style="width:20px;">#</th><th class="l">Team</th><th>P</th>
      <th class="lg-col-hide">W</th><th class="lg-col-hide">D</th><th class="lg-col-hide">L</th>
      <th class="lg-col-hide">GD</th><th>Pts</th><th class="lg-col-hide">Form</th>
    </tr></thead>
    <tbody>${standingsRows(rows)}</tbody>
  </table>`;
}

function groupLabel(title) {
  return `<div style="font-size:10px;font-weight:700;letter-spacing:.6px;text-transform:uppercase;color:${ACCENT};margin:14px 0 4px;">${title}</div>`;
}

// &#9472;&#9472; Main class &#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;
export class LeagueBrasileiroFem {
  constructor(containerId) {
    this.id   = containerId;
    this.root = null;
    this.data = {};
  }

  async init() {
    inject();
    this.root = document.getElementById(this.id);
    if (!this.root) return;
    const live = await fetchLiveBRFData();
    if (live) this.data = live;
    this.render();
  }

  render() {
    this.root.innerHTML = this._html();
    this._listen();
  }

  _html() {
    const d = this.data;
    const fixHtml  = fixtureSidebar(d.fixtures||[]);
    const scHtml   = scorerSidebar(d.scorers||[]);
    const mainHtml = this._standingsHtml(d);

    return `<div class="lg-wrap">
      <div class="lg-hero">
        <div class="lg-logo" style="background:transparent;"><img src="/images/league_bra.png" style="width:40px;height:40px;object-fit:contain;display:block;"></div>
        <div class="lg-hero-text"><h2>Brasileir&#227;o Feminino A1</h2><p>2025 &#183; Brazil &#183; 12 Clubs</p></div>
        <div class="lg-badge leaguebrasileirofem-badge">Brasileir&#227;o Fem &#127463;&#127479;</div>
      </div>
      <div class="lg-tabs" id="${this.id}-tabs">
        <div class="lg-tab leaguebrasileirofem-tab active" data-tab="standings">Standings</div>
        <div class="lg-tab leaguebrasileirofem-tab" data-tab="results">Results</div>
        <div class="lg-tab leaguebrasileirofem-tab" data-tab="stats">Stats</div>
        <div class="lg-tab leaguebrasileirofem-tab" data-tab="about">About</div>
        <div class="lg-tab" data-tab="clubs">Clubs</div>
        <div class="lg-tab" data-tab="media">Media</div>
        <div class="lg-tab" data-tab="classic">Classic</div>
      </div>
      <div class="lg-panel active" id="${this.id}-panel-standings">
        <div class="lg-layout">
          <div class="lg-main">${mainHtml}</div>
          <div class="lg-sidebar">
            <div class="lg-sidebar-sec"><div class="lg-sec-lbl">Fixtures &amp; Results</div>${fixHtml}</div>
            ${scHtml ? `<div class="lg-sidebar-sec"><div class="lg-sec-lbl">Top Scorers</div>${scHtml}</div>` : ''}
          </div>
        </div>
      </div>
      <div class="lg-panel" id="${this.id}-panel-results"><div style="padding:14px;">${this._resultsHtml(d)}</div></div>
      <div class="lg-panel" id="${this.id}-panel-stats"><div style="padding:14px;">${this._statsHtml(d)}</div></div>
      <div class="lg-panel" id="${this.id}-panel-clubs"><div style="padding:12px 0;"><div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(130px,1fr));gap:10px;">${(d.standings||[]).map(t=>`<div style="background:var(--card-bg,#fff);border:1px solid var(--border-color,#eee);border-radius:10px;padding:14px 10px;text-align:center;"><div style="width:44px;height:44px;border-radius:50%;background:${t.color||'#888'};display:flex;align-items:center;justify-content:center;margin:0 auto 8px;font-size:12px;font-weight:700;color:#fff;">${t.short||'?'}</div><div style="font-size:11px;font-weight:600;color:var(--text-color,#111);line-height:1.3;margin-bottom:4px;">${t.name||''}</div><div style="font-size:10px;color:var(--text-secondary,#888);">#${t.pos||''} &middot; ${t.pts||0} pts</div></div>`).join('')}</div></div></div>
      <div class="lg-panel" id="${this.id}-panel-media"><div style="padding:40px 20px;text-align:center;color:var(--text-secondary,#888);"><div style="font-size:15px;font-weight:600;">Media - Coming Soon</div></div></div>
      <div class="lg-panel" id="${this.id}-panel-classic"><div style="padding:40px 20px;text-align:center;color:var(--text-secondary,#888);"><div style="font-size:15px;font-weight:600;">Classic - Coming Soon</div></div></div>
      <div class="lg-panel" id="${this.id}-panel-about"><div style="padding:14px;" class="lg-about">${this._aboutHtml()}</div></div>
    </div>`;
  }

  _standingsHtml(d) {
    return `<table class="lg-table">
      <thead><tr>
        <th>#</th><th class="l">Club</th><th>P</th>
        <th class="lg-col-hide">W</th><th class="lg-col-hide">D</th><th class="lg-col-hide">L</th>
        <th class="lg-col-hide">GD</th><th>Pts</th><th class="lg-col-hide">Form</th>
      </tr></thead>
      <tbody>${standingsRows(d.standings||[])}</tbody>
    </table>${this._legend()}`;
  }

  _legend() {
    return `<div class="lg-legend">
      <div class="lg-leg-item"><div class="lg-leg-dot" style="background:#27ae60"></div>CONMEBOL Libertadores</div>
      ${undefined ? `<div class="lg-leg-item"><div class="lg-leg-dot" style="background:#3498db"></div>undefined</div>` : ''}
      ${"Relegation" ? `<div class="lg-leg-item"><div class="lg-leg-dot" style="background:#e74c3c"></div>Relegation</div>` : ''}
    </div>`;
  }

  _resultsHtml(d) {
    
    const done = (d.fixtures||[]).filter(f=>f.status==='FT');
    if(!done.length) return '<p style="color:var(--text-secondary,#888);font-size:13px;padding:20px 0">No results yet.</p>';
    return '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">' +
      done.map(f=>`<div style="background:var(--hover-bg,#f8f8f8);border-radius:10px;padding:10px;border:1px solid var(--border-color,#eee);">
        <div style="font-size:10px;color:var(--text-secondary,#888);margin-bottom:6px;">${fmtDate(f.date)}</div>
        <div style="display:flex;align-items:center;gap:6px;">
          <div style="flex:1;font-size:11px;text-align:right;">${f.home}</div>
          <div style="font-size:15px;font-weight:700;padding:2px 8px;background:var(--card-bg,#fff);border:1px solid var(--border-color,#eee);border-radius:5px;">${f.homeGoals}&#8211;${f.awayGoals}</div>
          <div style="flex:1;font-size:11px;">${f.away}</div>
        </div></div>`).join('') + '</div>';
    
  }

  _statsHtml(d) {
    
    const sc = (d.scorers||[]);
    return '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">' +
      ['Goals','Assists'].map((lbl,li)=>`<div style="background:var(--hover-bg,#f8f8f8);border-radius:10px;padding:12px;border:1px solid var(--border-color,#eee);">
        <div style="font-size:10px;font-weight:600;letter-spacing:.5px;text-transform:uppercase;color:var(--text-secondary,#888);margin-bottom:8px;">${lbl}</div>
        ${sc.slice(0,5).map((s,i)=>`<div style="display:flex;align-items:center;gap:7px;padding:4px 0;">
          <span style="font-size:10px;color:var(--text-secondary,#888);min-width:13px;">${i+1}</span>
          <div style="width:22px;height:22px;border-radius:50%;background:var(--hover-bg,#eee);display:flex;align-items:center;justify-content:center;font-size:8px;font-weight:600;">${s.initials}</div>
          <div style="flex:1;min-width:0;"><div style="font-size:11px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${s.name}</div><div style="font-size:10px;color:var(--text-secondary,#888);">${s.club}</div></div>
          <span style="font-size:13px;font-weight:700;color:${ACCENT};">${li===0?s.goals:s.assists||0}</span>
        </div>`).join('')}
      </div>`).join('') + '</div>';
    
  }

  

  _aboutHtml() {
    return `<div style="padding:14px;max-width:900px;"><div style="background:var(--card-bg,#fff);border:1px solid var(--border-color,#eee);border-radius:12px;padding:14px 16px;margin-bottom:12px;"><h4 style="margin:0 0 8px;font-size:13px;font-weight:700;color:#009C3B;">&#9632; Overview</h4><div style="font-size:12px;color:var(--text-secondary,#555);line-height:1.7;">Brazil&#39;s top women&#39;s football league, the Brasileirao Serie A1 Feminino. Home to some of the world&#39;s most technically gifted players and a nation with deep football passion at every level.</div></div><div style="background:var(--card-bg,#fff);border:1px solid var(--border-color,#eee);border-radius:12px;padding:14px 16px;margin-bottom:12px;"><h4 style="margin:0 0 8px;font-size:13px;font-weight:700;color:#009C3B;">&#9632; History</h4><div style="font-size:12px;color:var(--text-secondary,#555);line-height:1.7;">Women&#39;s football was banned in Brazil from 1941 to 1979. Since its rebirth, the sport has exploded. Corinthians, Santos, and Sao Paulo have been historic powerhouses of Brazilian women&#39;s football.</div></div><div style="background:var(--card-bg,#fff);border:1px solid var(--border-color,#eee);border-radius:12px;padding:14px 16px;margin-bottom:12px;"><h4 style="margin:0 0 8px;font-size:13px;font-weight:700;color:#009C3B;">&#9733; Honours</h4><div style="font-size:12px;color:var(--text-secondary,#555);line-height:1.7;"><strong>Corinthians</strong> are the dominant modern force with 6 consecutive titles (2018&#8211;2023). <strong>Santos</strong> and <strong>Sao Paulo</strong> have strong historic pedigree in the competition.</div></div><div style="background:var(--card-bg,#fff);border:1px solid var(--border-color,#eee);border-radius:12px;padding:14px 16px;margin-bottom:12px;"><h4 style="margin:0 0 8px;font-size:13px;font-weight:700;color:#009C3B;">&#9733; Stars</h4><div style="font-size:12px;color:var(--text-secondary,#555);line-height:1.7;">Marta &#8212; 6x FIFA World Player of the Year &#8212; is Brazil&#39;s greatest. Current stars Debinha, Kerolin, and Angelina all play in the NWSL, bringing global attention to Brazilian football.</div></div><div style="background:var(--card-bg,#fff);border:1px solid var(--border-color,#eee);border-radius:12px;padding:14px 16px;margin-bottom:12px;"><h4 style="margin:0 0 8px;font-size:13px;font-weight:700;color:#009C3B;">&#9632; TV &amp; Media</h4><div style="font-size:12px;color:var(--text-secondary,#555);line-height:1.7;">Broadcast on <strong>SporTV</strong> and <strong>Caze TV</strong>. Brazilian women&#39;s football audiences have surged since the 2019 World Cup and Marta&#39;s global fame and advocacy.</div></div><div style="background:var(--card-bg,#fff);border:1px solid var(--border-color,#eee);border-radius:12px;padding:14px 16px;margin-bottom:12px;"><h4 style="margin:0 0 8px;font-size:13px;font-weight:700;color:#009C3B;">&#9632; World Stage</h4><div style="font-size:12px;color:var(--text-secondary,#555);line-height:1.7;">Brazil has reached multiple World Cup quarter-finals. Brazilian players are highly sought in NWSL, WSL, and Liga F, bringing global attention to the domestic Brasileirao competition.</div></div><div style="background:var(--card-bg,#fff);border:1px solid var(--border-color,#eee);border-radius:12px;padding:14px 16px;margin-bottom:12px;"><h4 style="margin:0 0 8px;font-size:13px;font-weight:700;color:#009C3B;">&#9632; Key Facts</h4><div style="font-size:12px;color:var(--text-secondary,#555);line-height:1.7;"><span style="display:inline-block;background:var(--hover-bg,#f5f5f5);border-radius:6px;padding:3px 8px;margin:2px;font-size:11px;font-weight:600;">16 clubs</span><span style="display:inline-block;background:var(--hover-bg,#f5f5f5);border-radius:6px;padding:3px 8px;margin:2px;font-size:11px;font-weight:600;">Founded 2013</span><span style="display:inline-block;background:var(--hover-bg,#f5f5f5);border-radius:6px;padding:3px 8px;margin:2px;font-size:11px;font-weight:600;">Mar&#8211;Nov</span><span style="display:inline-block;background:var(--hover-bg,#f5f5f5);border-radius:6px;padding:3px 8px;margin:2px;font-size:11px;font-weight:600;">6x Corinthians</span></div></div></div>`;
  }

  _listen() {
    this.root.querySelectorAll('[data-tab]').forEach(t => {
      t.addEventListener('click', () => {
        this.root.querySelectorAll('[data-tab]').forEach(x => x.classList.remove('active'));
        this.root.querySelectorAll('.lg-panel').forEach(x => x.classList.remove('active'));
        t.classList.add('active');
        this.root.querySelector(`#${this.id}-panel-${t.dataset.tab}`)?.classList.add('active')
        // Classic & Media lazy init
        const _tn = t.dataset.tab || '';
        if (_tn === 'classic') {
          const _ce = this.root && this.root.querySelector('[id$="-panel-classic"]');
          if (_ce && !_ce._cpm) { new LeagueClassicPage(_ce, 'brasil').init(); _ce._cpm = true; }
        }
        if (_tn === 'media') {
          const _me = this.root && this.root.querySelector('[id$="-panel-media"]');
          if (_me && !_me._mmm) { new LeagueMediaMini(_me, 'brasil').init(); _me._mmm = true; }
        };
      });
    });
  }
}
